import { all, delay, put, call, takeLatest } from "redux-saga/effects";
import { getTokens } from "services/api";
import { tokens, setTokens } from "store/reducers/tokenStore";
import {
  DELAY_OF_GEETING_TOKEN,
  DELAY_OF_GEETING_TOKEN_IN_CATCH,
} from "configs/constants";

function* tokensSaga(): any {
  while (true) {
    try {
      const response = yield call(() => getTokens());
      yield put({
        payload: { response },
        type: setTokens.type,
      });
      yield delay(DELAY_OF_GEETING_TOKEN);
    } catch (err) {
      yield delay(DELAY_OF_GEETING_TOKEN_IN_CATCH);

      console.log(err, "err");
    }
  }
}

export default function* root() {
  yield all([takeLatest(tokens.type, tokensSaga)]);
}
